/**
 * P9-07 · One place that turns a failed-mutation error into the message a
 * shopper sees. Previously every call site hand-rolled `err instanceof Error ?
 * err.message : "…"`, none of them offline-aware — so a dropped connection
 * surfaced as a bare "Failed to fetch". When the browser knows it's offline we
 * say so plainly (the `<OfflineBanner>` reinforces it); otherwise we prefer the
 * server's own message, falling back to a generic line.
 */
export function mutationErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return "You’re offline — reconnect and try again.";
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }
  return fallback;
}
